import React from 'react';
import {
  IconPlus,
  IconServer
} from '@tabler/icons-react';

const EmptyState = ({ onCreate }) => {
  return (
    <div className="text-center py-16">
      <div className="w-16 h-16 mx-auto mb-5 bg-gradient-to-br from-primary-500 to-yellow-400 rounded-2xl flex items-center justify-center">
        <IconServer className="w-8 h-8 text-black" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
        Нет настроенных нод
      </h3>
      <p className="text-gray-600 dark:text-dark-400 mb-6">
        Добавьте свою первую relay ноду
      </p>
      <button
        onClick={onCreate}
        className="inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 rounded-lg font-medium text-black transition-colors"
      >
        <IconPlus className="w-5 h-5 mr-2" />
        <span>Добавить ноду</span>
      </button>
    </div>
  );
};

export default EmptyState;